import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { StyledWrapper } from 'athenaeum';

import styles from './section.module.scss';

const Section = (props) => {
  const {
    children,
    className,
    pullLeft,
    pullRight,
    backgroundColor,
    fullwidth,
    id,
    noPadding
  } = props;

  const css = ({ breakpoints, colors }) => `
    ${backgroundColor && `background-color: ${colors[backgroundColor]};`}

    @media ${breakpoints.tabletOnly} {
      ${
        pullRight && `background: linear-gradient(90deg, #fff 50%, ${colors[backgroundColor]} 50%);`
       };

      ${
        pullLeft && `background: linear-gradient(90deg, ${colors[backgroundColor]} 50%, #fff 50%);`
       };
    }

    @media ${breakpoints.desktop} {
      ${
        pullRight && `background: linear-gradient(90deg, #fff 50%, ${colors[backgroundColor]} 50%);`
       };

      ${
        pullLeft && `background: linear-gradient(90deg, ${colors[backgroundColor]} 50%, #fff 50%);`
       };
    }
  `;

  return (
    <StyledWrapper
      className={cx(className, styles['section-wrapper'], noPadding && styles['no-padding'])}
      css={css}
      component="section"
      id={id}
    >
      <div className={cx(styles.section, { fullwidth }, noPadding && styles['no-padding'])}>
        { children }
      </div>
    </StyledWrapper>
  );
};

Section.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  className: PropTypes.string,
  pullRight: PropTypes.bool,
  pullLeft: PropTypes.bool,
  backgroundColor: PropTypes.string,
  fullwidth: PropTypes.bool,
  noPadding: PropTypes.bool,
  id: PropTypes.string,
};

Section.defaultProps = {
  fullwidth: false,
  noPadding: false
};

export default Section;



// WEBPACK FOOTER //
// ../src/components/Section/index.js